import styled, { css } from 'styled-components';

import {
  breakpoints,
  IBasicStyledProps,
  InfoCircleIcon,
  theme,
} from '@notino/react-styleguide';

export const Wrapper = styled.div<{ newDesign: boolean }>`
  line-height: 1.3125rem;
  margin: 1rem 0;
  font-size: 0.875rem;

  ${({ newDesign }) =>
    newDesign &&
    css`
      margin: 0.75rem 0 1rem;
      @media (min-width: ${breakpoints.lg}) {
        margin: 1rem 0;
      }
    `}
`;

export const CodeBlock = styled.span`
  color: ${theme.color.text.secondary};
`;

export const CodeName = styled.span`
  display: none;

  @media (min-width: ${breakpoints.sm}) {
    display: inline;
  }
`;

export const Separator = styled.span<{ newDesign: boolean }>`
  color: ${({ newDesign }) =>
    newDesign ? theme.color.text.disabled : theme.color.text.secondary};
`;

export interface IAvailabilityProps extends IBasicStyledProps {
  highlight: boolean;
  newDesign: boolean;
}

export const Availability = styled.span<IAvailabilityProps>`
  color: ${(props: IAvailabilityProps) =>
    props.highlight
      ? props.theme.color.text.negative
      : props.theme.color.text.positive};

  ${({ newDesign, highlight }) =>
    newDesign
      ? css`
          font-weight: ${highlight ? 500 : 'normal'};
        `
      : css`
          font-weight: ${highlight ? 'bold' : 'normal'};
        `}
`;

export interface IAdditionalDescriptionStyledProps extends IBasicStyledProps {
  damage?: boolean;
  highlight?: boolean;
}
// prettier-ignore
export const AdditionalDescriptionStyled = styled.p<IAdditionalDescriptionStyledProps>`
  color: ${(props: IAdditionalDescriptionStyledProps) =>
    props.damage ? props.theme.color.text.negative : props.theme.color.text.primary};
  font-weight: ${(props: IAdditionalDescriptionStyledProps) =>
    props.highlight ? 'bold' : 'normal'};
  margin: 0;
`;

export const AdditionalText = styled.div`
  margin: 0;
`;

export const StyledInfoIcon = styled(InfoCircleIcon)`
  margin-bottom: 4px;
`;

export const TooltipContent = styled.div`
  max-width: max-content;
  width: 18rem;
  padding: 0.5rem;
`;
